import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { SurveysListPage } from '@/features/marketing/surveys';
import { formatDocumentTitle } from '@/lib/document-title';

/** Marketing › Surveys — every client survey, its status and how many clients answered. */
export const Route = createFileRoute('/_auth/$orgId/marketing/surveys')({
  component: SurveysRoute,
});

function SurveysRoute() {
  const { orgId } = Route.useParams();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Surveys', 'Marketing')}</title>
      </Helmet>
      <SurveysListPage routeOrgId={orgId} />
    </>
  );
}
